import React from "react";
import { Box, Typography } from "@mui/material";
import { formatPersianDate } from "../../../../utils/date";
import { convertToTime } from "../../../../utils/time";

export const InviteListItem = ({ index, phone, date }) => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: { xs: 1.5, sm: 2 },
            py: { xs: 0.75, sm: 1 },
            bgcolor: "#F7F7F7",
            flexWrap: { xs: "nowrap", sm: "wrap" },
            mb: 1,
        }}
    >
        <Typography
            sx={{
                fontSize: { xs: "0.875rem", sm: "1rem" },
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: { xs: "60%", sm: "70%" },
                direction: "rtl",
            }}
        >
            {` ${phone} - ${index}`}
        </Typography>
        <Typography
            color="text.secondary"
            sx={{
                fontSize: { xs: "0.75rem", sm: "0.875rem" },
                whiteSpace: "nowrap",
                ml: { xs: 1, sm: 2 },
            }}
        >
            {`${formatPersianDate(date?.split("T")[0], {
                day: "numeric",
                month: "numeric",
                year: "numeric",
                weekday: "long",
            })}, ${convertToTime(date)}`}
        </Typography>
    </Box>
);
